module.exports = { id: "arrow-right", url: "/build/app/img/symbols.svg#arrow-right", viewBox: "", toString: function() { return this.url; } };